"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlaTimeUnitEnum = void 0;
var SlaTimeUnitEnum;
(function (SlaTimeUnitEnum) {
    SlaTimeUnitEnum["Hours"] = "h";
    SlaTimeUnitEnum["Days"] = "d";
})(SlaTimeUnitEnum = exports.SlaTimeUnitEnum || (exports.SlaTimeUnitEnum = {}));
